export default __webpack_public_path__ + "be5ff4733b7713ad03db45ddea4bc223.svg";